$(document).ready(function(){  
  if(location.href.indexOf('#fabric') > -1){    
    console.log($('body .coll-check').length,'readyyyyyy'); 
    $(".popup-area").addClass("active");
    $("body").addClass("active");
  }

  window.selectedSwatchVariantIds = window.selectedSwatchVariantIds || [];

  $('body').on('change','.coll-check', function(){
    var variantId = $(this).attr('data-variant-id');
    if ($('.coll-check[type=checkbox]:checked').length > 9) {
        $(this).prop('checked', false);
        alert("You already have 9 swatches selected");
    } else {
        if ( $(this).prop('checked') == true) {
            if (variantId && window.selectedSwatchVariantIds.indexOf(variantId) === -1) {
                window.selectedSwatchVariantIds.push(variantId);
            }
        } else {
            var idx = window.selectedSwatchVariantIds.indexOf(variantId);
            if (idx > -1) {
                window.selectedSwatchVariantIds.splice(idx, 1);
            }
        }
    }
  });
  
  var n$1=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw "state should be an object";var t;},t$4=function(n,t,e,c){return (r=n,r.reduce(function(n,t,e){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,e){return n.concat(t[e]||[])},[]).map(function(n){return n(e,c)});var r;},e$1=a(),c$1=e$1.on,r$1=e$1.emit,o=e$1.hydrate,u=e$1.getState;function a(e){void 0===e&&(e={});var c={};return {getState:function(){return Object.assign({},e)},hydrate:function(r){return n$1(r),Object.assign(e,r),function(){var n=["*"].concat(Object.keys(r));t$4(n,c,e);}},on:function(n,t){return (n=[].concat(n)).map(function(n){return c[n]=(c[n]||[]).concat(t)}),function(){return n.map(function(n){return c[n].splice(c[n].indexOf(t),1)})}},emit:function(r,o,u){var a=("*"===r?[]:["*"]).concat(r);(o="function"==typeof o?o(e):o)&&(n$1(o),Object.assign(e,o),a=a.concat(Object.keys(o))),t$4(a,c,e,u);}}}
  var CustomEvents = {
  cartItemAdded: "flu:cart:item-added",
  cartUpdated: "flu:cart:updated",
  cartError: "flu:cart:error",
  productVariantChange: "flu:product:variant-change",
  productQuanityUpdate: "flu:product:quantity-update",
  quickCartOpen: "flu:quick-cart:open",
  quickCartClose: "flu:quick-cart:close",
  // For use with apps. No need to use `flu:`
  quickViewLoaded: "quickview:loaded"
};
  function getCart() {
  return fetch$1("".concat(theme.routes.cart.base, ".js"), {
    method: "GET",
    credentials: "include"
  }).then(res => res.json()).then(data => {
    if (localStorageAvailable$1() && ls$2.get()) {
      data.items = reorderCartItems(data.items, ls$2.get());
    }

    return data;
  });
}
  var open = () => {
    node.classList.add("is-visible");
    r$1("drawerOverlay:show");
    var reviewsToggle = node.querySelector(".spr-summary-actions-togglereviews");

    if (reviewsToggle) {
      reviewsToggle.tabIndex = -1;
    }

    setTimeout(() => {
      focusTrap.activate();
    }, 50);
  };
  var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
  var ls$2 = {
  get: () => JSON.parse(localStorage.getItem("cartItemOrder")),
  set: val => localStorage.setItem("cartItemOrder", val)
};
function fetch$1(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return {ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(s.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t;}),t(a());},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null);})}
  function localStorageAvailable$1() {
  var test = "test";

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}
  
  function reorderCartItems(items, sortOrder) {
  return items.sort(function (a, b) {
    return sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id);
  });
}

if($('body').hasClass('fabric-swatches-pages')){   
}
  
$(".fixed-sample, .product-fabric-swatches").on("click", function (e) {
   e.preventDefault();
  $(".fixed-samples").click();
});
$(".fixed-samples,.fabric-swatches").click(function(e){ 
  e.preventDefault();
  if($(window).width() < 768){
    if($('#header-sidebar-menu').length){
      $('#header-sidebar-menu').removeAttr('open');
    }
  }else{
    if($('#navigation-drawer-1').length){
      $('#navigation-drawer-1').removeAttr('open');
    }
  }
$(".popup-area").addClass("active");
  $("body").addClass("active");
});
    
// $("li.nav__item.nav__item-swatches a").click(function(){
// $(".popup-area").addClass("active");
//     $("body").addClass("active");
// });
    
// $("ul.drawer-menu__primary-links li.drawer-menu__item:nth-last-child(2) a.drawer-menu__link").click(function(){
// $(".popup-area").addClass("active");
// });
    
// Fabric swatches all fuction start

$(".popup-area .content .close").click(function(){
  $(".popup-area").removeClass("active");
  $("body").removeClass("active");
});

$(document).ready(function() {
   CheckCart();
});
function getCart() {
  return fetch$1("".concat(theme.routes.cart.base, ".js"), {
    method: "GET",
    credentials: "include"
  }).then(res => res.json()).then(data => {
    if (localStorageAvailable$1() && ls$2.get()) {
      data.items = reorderCartItems(data.items, ls$2.get());
    }
    return data;
  });
}


$(".button-area button.product-form__color-swatch").click(function(){
    $(this).toggleClass("selected");    
});

function CheckCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      var cartItems = cart.items;
      window.selectedSwatchVariantIds = [];

      for (var i = 0; i < cartItems.length; i++) {
        var item = cartItems[i];
        var $matchingCheckbox = $('.coll-check[data-variant-id="' + item.variant_id + '"]');
        if ($matchingCheckbox.length) {
          $matchingCheckbox.prop('checked', true);
          window.selectedSwatchVariantIds.push(String(item.variant_id));
        }
      }
    },
    error: addToCartFail
  });
}



 

function addToCartFail(obj, status) { 
    console.log("error");
}

// $('.addswatch span').click(function(){    
//  addItemToCart($(this).attr("data-value"));
// });

//   function addItemToCart(variant_id) {
//     data = {
//       "id": variant_id,
//       "quantity": 1
//     }
//    jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       dataType: 'json',
//       success: function() { 
//  console.log('success')
// $(".success-text").show();
//     setTimeout(function() {      
// location.reload();
//        }, 2500);   
//       }
//     });
//   }

if ($(window).width() < 1025){  
  $(document).ready(function(){
    if( $('.customfilter').length){
    $('.customfilter').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1
    });
      }
  }); 
}

$("li.nav__item.nav__item-free-swatches a").removeAttr("href");
$(".addswatch span.order-popup, li.nav__item.nav__item-free-swatches a.nav__link.nav__item-primary").click(function(){
$("body .fixed-sample").trigger("click");
});

// Build a real multi-item cart add from the selected swatch variants.
// Mirrors the theme's own ProductForm flow (js/common/product/product-form.js):
// 'cart:prepare-bundled-sections' lets <cart-drawer> register the section it needs,
// then 'variant:add' (opens the drawer) and 'cart:change' (re-renders drawer + count)
// are dispatched with the fresh cart.
var swatchSubmitting = false;

$("#checkout-btn").off("click").on("click", function (e) {
  e.preventDefault();

  // Ignore repeat clicks while a request is already in flight
  if (swatchSubmitting) {
    return;
  }

  var $btn = $(this);
  var $error = $(".error_mssg");

  if (!window.selectedSwatchVariantIds || window.selectedSwatchVariantIds.length === 0) {
    $error.html($btn.attr("data-error") || "Please select at least one option");
    return;
  }

  swatchSubmitting = true;
  $error.text("");

  fetch(window.Shopify.routes.root + "cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (currentCart) {
      // Only add swatches that are not already in the cart, so a second click
      // (or re-opening the popup) can never raise a swatch above quantity 1.
      var inCart = currentCart.items.map(function (item) {
        return String(item.variant_id);
      });
      var toAdd = window.selectedSwatchVariantIds.filter(function (id) {
        return inCart.indexOf(String(id)) === -1;
      });

      if (toAdd.length === 0) {
        $error.text($btn.attr("data-cartmsg") || "You have already selected these swatches.");
        return;
      }

      var items = toAdd.map(function (id) {
        return { id: id, quantity: 1 };
      });

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (errJson) {
              throw errJson;
            });
          }
          return response.json();
        })
        .then(function (responseJson) {
          $(".popup-area").removeClass("active");
          $("body").removeClass("active");

          return fetch(window.Shopify.routes.root + "cart.js")
            .then(function (r) {
              return r.json();
            })
            .then(function (cartContent) {
              cartContent.sections = responseJson.sections;

              document.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                  items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
                  cart: cartContent
                }
              }));

              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: cartContent
                }
              }));
            });
        });
    })
    .catch(function (err) {
      console.error("Swatch cart: add to cart failed", err);
      $error.text("Something went wrong, please try again.");
    })
    .then(function () {
      swatchSubmitting = false;
    });
});
});